import Navbar from "@/components/Navbar";
import MobileNav from "@/components/MobileNav";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Layout({ children, hideFooter }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1 pb-16 lg:pb-0">{children}</main>
      {!hideFooter && <Footer />}
      <MobileNav />
      <ChatWidget />
    </div>
  );
}
